<div class="order-edit-detail-container" id="materials">
  <app-ccr-edit-material
    *ngIf="editMaterial"
    [saving]="panelStatus.busy"
    [definitions]="definitions"
    [material]="editMaterial"
    [materialTypes]="materialTypes"
    [panelStatus]="panelStatusMaterial"
    (nextClicked)="nextClickedFn()"
    (saveMaterialClicked)="saveMaterialClicked.emit($event)"
  >
  </app-ccr-edit-material>

  <app-ccr-material-lines
    [materials]="florderDetail.ccr.ccrLineItems"
    [definitions]="definitions"
    [panelStatus]="panelStatusMaterial"
    [readonly]="!(panelStatus.isNew || panelStatus.isEdit)"
    [materialTypes]="materialTypes"
    [title]="'CCR_LINES'"
    [palletQuantity]="florderDetail.palletQuantity"
    (editMaterialClicked)="editMaterialClicked($event)"
    (removeMaterialClicked)="removeMaterialClicked.emit($event)"
  >
  </app-ccr-material-lines>
</div>
